module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-note ui modal segment"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("New note")]), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Title")]), _c('input', {
    attrs: {
      "type": "text",
      "name": "label",
      "placeholder": "\"Rent\"",
      "default": _vm.title
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Note")]), _c('textarea', {
    attrs: {
      "name": "desc",
      "placeholder": "\"Account info is ...\"",
      "default": _vm.content
    }
  })])])]), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui cancel button"
  }, [_vm._v("Cancel")]), _c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.add_note
    }
  }, [_vm._v("Add")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44e4b9df!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddNote.vue
// module id = 56
// module chunks = 0